<template>
  <div class="box">
    <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
      <el-form-item>
        <el-date-picker
          v-model="dateTime"
          type="monthrange"
          align="right"
          unlink-panels
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始月"
          end-placeholder="结束月"
          :picker-options="pickerOptions"
          @change="changeDate">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select multiple collapse-tags v-model="searchForm.categoryId" clearable style="width: 200px;margin-right: 5px"  placeholder="请选择栏目，默认全选">
          <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
          </el-option>
        </el-select>
        <el-select multiple remote filterable
                   v-model="searchForm.carId" clearable
                   style="width: 500px;margin-right: 5px"
                   placeholder="输入车牌号，查询排名"
                   :remote-method="remoteMethod"
                   :loading="remoteLoading">
          <el-option v-for="item in carList" :key="item.groupId" :label="item.count>0 ? item.carNumber + '--自己上车'+item.count+'次' : item.carNumber" :value="item.groupId" :class="item.count>0 ? 'blacklist' : ''">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button size="mini" type="primary" @click="search" icon="el-icon-search" :loading="loading">搜索</el-button>
    </el-form>
    <div>
      <el-table
        v-loading="loading"
        :data="driverList.records"
        :row-class-name="blackList"
        stripe
        :height="windowHeight"
        style="width: 100%;z-index: 1;font-size: 12px">
        <el-table-column
          prop="rank"
          label="排名"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          label="姓名"
          label-class-name="header">
          <template slot-scope="scope">
            <el-popover
              :open-delay=400
              placement="left"
              trigger="click" >
              <div>
                <ul class="basic-list">
                  <li :key="item" v-for="item in scope.row.driverName.split(',')">{{item}}</li>
                </ul>
              </div>
              <p slot="reference" v-if="scope.row.driverName.split(',').length >1">{{scope.row.driverName.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
              <p slot="reference" v-else>{{scope.row.driverName.split(',')[0]}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="电话"
          label-class-name="header">
          <template slot-scope="scope">
            <el-popover
              :open-delay=400
              placement="left"
              trigger="click" >
              <div>
                <ul class="basic-list">
                  <li :key="item" v-for="item in scope.row.phone.split(',')">{{item}}</li>
                </ul>
              </div>
              <p slot="reference" v-if="scope.row.phone.split(',').length >1">{{scope.row.phone.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
              <p slot="reference" v-else>{{scope.row.phone.split(',')[0]}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="carNumber"
          label="车牌"
          label-class-name="header">
          <template slot-scope="scope">
            <el-popover
              :open-delay=400
              placement="left"
              trigger="click" >
              <div>
                <ul class="basic-list" v-if="scope.row.carNumber != null">
                  <li :key="item" v-for="item in scope.row.carNumber.split(',')">{{item}}</li>
                </ul>
              </div>
              <p slot="reference" v-if="scope.row.carNumber != null && scope.row.carNumber.split(',').length >1">{{scope.row.carNumber.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
              <p slot="reference" v-else>{{scope.row.carNumber}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="地址"
          label-class-name="header">
          <template slot-scope="scope">
            <el-popover
              :open-delay=400
              placement="left"
              trigger="click" >
              <div>
                <ul class="basic-list" v-if="scope.row.address != null">
                  <li :key="item" v-for="item in scope.row.address.split(',')">{{item}}</li>
                </ul>
              </div>
              <p slot="reference" v-if="scope.row.address != null && scope.row.address.split(',').length >1">{{scope.row.address.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
              <p slot="reference" v-else>{{scope.row.address}}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="总吨位"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{scope.row.tonnage}}吨</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="总额"
          label-class-name="header">
          <template slot-scope="scope">
            <p>{{ scope.row.total }}元</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="总拉货数"
          label-class-name="header">
          <template slot-scope="scope">
            <p>{{ scope.row.count }}趟</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="driverList.current"
        :page-sizes="[15, 30, 50, 100]"
        :page-size="driverList.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="driverList.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getAppInfo } from '../../../api/app'
import { driverOrderBySale } from '../../../api/ordersStatistics'
import { getCarForNumber } from '../../../api/car'

export default {
  name: 'driverOrder',
  data: function () {
    return {
      appInfo: {},
      dateTime: [],
      searchForm: {
        appId: '',
        categoryId: [],
        carId: [],
        areaCode: '',
        areaName: '',
        orderCurrent: 1,
        orderPageSize: 15
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      carList: [],
      driverList: [],
      windowHeight: '',
      loading: false,
      remoteLoading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.searchForm.appId = to.params.id
      vm.search()
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
      })
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 310
  },
  methods: {
    changeDate (item) {
      if (item !== null) {
        this.searchForm.startDate = item[0]
        this.searchForm.endDate = item[1]
      } else {
        this.searchForm.startDate = null
        this.searchForm.endDate = null
      }
    },
    remoteMethod (query) {
      let _this = this
      if (query !== '') {
        let timer
        clearTimeout(timer)
        this.loading = true
        timer = setTimeout(() => {
          this.loading = false
          getCarForNumber(query, _this.searchForm.appId).then((response) => {
            if (response.data.data.records.length > 0) {
              let map = new Map()
              let arr = []
              response.data.data.records.forEach((element) => {
                map.set(element.carId, {carNum: element.carNumber, count: element.count, groupId: element.groupId})
              })
              map.forEach((value, key) => {
                arr.push({carId: key, carNumber: value.carNum, count: value.count, groupId: value.groupId})
              })
              _this.carList = arr
            } else {
              _this.carList = []
            }
          })
        }, 200)
      } else {
        this.carList = []
      }
    },
    handleSizeChange (val) {
      this.searchForm.orderPageSize = val
      this.search()
    },
    handleCurrentChange (val) {
      this.searchForm.orderCurrent = val
      this.getList()
    },
    getList () {
      this.loading = true
      let _this = this
      driverOrderBySale(this.searchForm).then((response) => {
        _this.driverList = response.data.data
        setTimeout(() => {
          _this.loading = false
        }, 1000)
      }).catch(() => {
        _this.loading = true
      })
    },
    blackList ({row}) {
      if (row.selfCount > 3) {
        return 'blackListPush'
      } else if (row.selfCount > 0) {
        return 'blackList'
      }
      return ''
    },
    search () {
      this.searchForm.orderCurrent = 1
      this.getList()
    }
  }
}
</script>

<style  lang="stylus" rel="stylesheet/stylus">
  .blacklist
    color #d53131
  .blackList
    color #e86a6a
  .blackListPush
    color red
  .el-select__input
    border none !important
  .box
    padding 18px
    background #fff;
    border-radius 5px
    font-size 12px
    transition .3s
    box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5)
</style>
